import { Cip, Institution, UsCitizenshipStatus, UsState } from './eligibility';
import { RequireAdditionalFinancingOption } from './eslProfileFinancingForm';
import { StoredFile } from './sponsorshipApplication';

// TODO: Remove hardcoded values and replace with actual backend request for TitleIVCredentialLevels
export enum DegreeType {
  UNDERGRADUATE_CERTIFICATE = 'Undergraduate Certificate',
  ASSOCIATE = 'Associate\'s Degree',
  BACHELOR = 'Bachelor\'s Degree',
  POST_BACCALAUREATE_CERTIFICATE = 'Post Baccalaureate Certificate',
  MASTER_DEGREE = 'Master\'s Degree',
  DOCTORAL_DEGREE = 'Doctoral Degree',
  FIRST_PROFESSIONAL_DEGREE = 'First Professional Degree',
  GRADUATE_CERTIFICATE = 'Graduate/Professional Certificate',
}

export const degreeTypes = [
  DegreeType.UNDERGRADUATE_CERTIFICATE,
  DegreeType.BACHELOR,
  DegreeType.ASSOCIATE,
  DegreeType.POST_BACCALAUREATE_CERTIFICATE,
  DegreeType.MASTER_DEGREE,
  DegreeType.DOCTORAL_DEGREE,
  DegreeType.FIRST_PROFESSIONAL_DEGREE,
  DegreeType.GRADUATE_CERTIFICATE,
];

export const sponsorshipDegreeTypes = [
  DegreeType.ASSOCIATE,
  DegreeType.BACHELOR,
  DegreeType.MASTER_DEGREE,
  DegreeType.DOCTORAL_DEGREE,
  DegreeType.UNDERGRADUATE_CERTIFICATE,
];

export interface CommonApplicationProfileFinancingInfo {
  additional_financing: RequireAdditionalFinancingOption | null;
  existing_student_loans: boolean;
}

export interface MailingAddressInfo {
  address_line: string | null;
  address_detail: string | null;
  city: string | null;
  state: UsState | null;
  zip: string | null;
}

export enum EnrollmentStatus {
  ENROLLED = 'ENROLLED',
  NOT_ENROLLED = 'NOT_ENROLLED',
}

export interface CommonApplicationProfile extends CommonApplicationProfileFinancingInfo, MailingAddressInfo {
  id: string;
  citizenship_status: UsCitizenshipStatus;
  current_gpa: string;
  degree_type: DegreeType;
  expected_graduation_date: string;
  expected_enrollment_date: string;
  enrollment_status: EnrollmentStatus | null;
  institution: Institution;
  major: Cip;
  institution_acceptance_letter?: StoredFile | null;
  student_email: string;
  student_first_name: string;
  student_last_name: string;
  student_name: string;
  student_phone_number: string;
}
